import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CartCreateDto, ProductOption, ADD_SOURCE_LIST_NAME_KEY, buildAddSource } from '../../../../dto';
import { Utils } from '../../../../common';
import { CartService, ProductService, GaService, UtmStorageService } from '../../../../services';
import { BaseComponent } from '../../../../core';
import { PRODUCT_SHIPPING_TYPE } from '../../../../shared';
import * as CartStore from '../../../../store/cart';
@Component({
  selector: 'app-select-bulk-product',
  templateUrl: './select-bulk-product.component.html',
  styleUrls: ['./select-bulk-product.component.scss'],
  standalone: false,
})
export class SelectBulkProductComponent extends BaseComponent implements OnInit, OnDestroy {
  private cartService = inject(CartService);
  productService = inject(ProductService);
  private gaService = inject(GaService);
  private utmStorage = inject(UtmStorageService);

  selectedProducts;
  sendSelectedProducts;
  isShowAddToCartModal: boolean;
  isCheckedAll;
  totalLength;
  ngOnInit() {
    this.productService.openOptionSubject$.subscribe(() => {
      this.selectedProducts = this.productService.selectProducts;
      this.totalLength = this.selectedProducts.length + this.productService.cartsProductLength;
      if (this.totalLength > this.productService.maxProduct) {
        this.selectedProducts = this.selectedProducts.map((selectedProduct, index) => {
          if (index + this.productService.cartsProductLength < this.productService.maxProduct) {
            return selectedProduct;
          } else {
            return {
              ...selectedProduct,
              addBulkChecked: false,
            };
          }
        });
      }
      this.cehckAllSelect();
      this.sendSelectedProducts = this.selectedProducts;
      this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
      this.isShowAddToCartModal = true;
    });
  }

  checkUquickStockMoq(productOption: ProductOption) {
    if (!productOption.isFixedMoq && productOption.rocketStock) {
      if (productOption.rocketStock < 5) {
        productOption.minMoq = 1;
        productOption.inboxQuantity = 1;
      } else {
        if (productOption.minMoq === 1) {
          productOption.minMoq = 1;
          productOption.inboxQuantity = 1;
        } else {
          productOption.minMoq = 5;
          productOption.inboxQuantity = 5;
        }
      }
    }
    return productOption;
  }

  addToSelect(product) {
    let _selectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);

    if (!product.addBulkChecked) {
      if (this.productService.cartsProductLength + _selectedProducts.length >= this.productService.maxProduct) {
        const dialog = this._openDialog({
          message: `Cannot hold any more. Maximum of ${this.productService.maxProduct} can be held.`,
          close: () => {
            dialog.close();
          },
        });
        return;
      }
    }

    product.addBulkChecked = !product.addBulkChecked;
    this.cehckAllSelect();
    this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
  }

  addBulkProducts() {
    if (this.sendSelectedProducts.length > 0) {
      let ret: any = [];
      const analyticsSourceProducts = this.selectedProducts.filter((product) => product.addBulkChecked);
      this.selectedProducts = this.selectedProducts.filter((selectedProduct) => {
        if (selectedProduct.addBulkChecked) {
          let setShippingType = () => {
            if (selectedProduct.productOption.europeStock > 0) {
              return PRODUCT_SHIPPING_TYPE.UDIRECT;
            } else if (selectedProduct.productOption.americaStock > 0) {
              return PRODUCT_SHIPPING_TYPE.ADIRECT;
            } else {
              return Utils.toNumber(selectedProduct.productOption.minMoq) > selectedProduct.productOption.rocketStock
                ? PRODUCT_SHIPPING_TYPE.GENERAL
                : Utils.toNumber(selectedProduct.productOption.minMoq) <= selectedProduct.productOption.rocketStock
                  ? PRODUCT_SHIPPING_TYPE.ROCKET
                  : Utils.toNumber(selectedProduct.productOption.minMoq) <= selectedProduct.productOption.stock
                    ? PRODUCT_SHIPPING_TYPE.STOCK
                    : PRODUCT_SHIPPING_TYPE.GENERAL;
            }
          };
          ret.push(
            new CartCreateDto({
              mapperSaleProductId: Utils.toNumber(selectedProduct.id),
              quantity: Utils.toNumber(this.checkUquickStockMoq(selectedProduct.productOption).minMoq),
              shippingType: setShippingType(),
              isForce: true,
              addSource: buildAddSource(selectedProduct.addSource?.[ADD_SOURCE_LIST_NAME_KEY], this.utmStorage.get()),
            })
          );
          return false;
        } else {
          return selectedProduct;
        }
      });
      this.productService.selectProducts = this.selectedProducts;
      this.productService.emitResetProduct(this.selectedProducts);

      this.cartService.addToCarts(ret).subscribe(
        (carts) => {
          const dialog = this._openDialog({
            message: this.i18n.t('CART.ADDED_MIN'),
            close: () => {
              dialog.close();
            },
          });
          this.store.dispatch(new CartStore.SetCart(carts));
          this.gaService.logAddToCart(carts, undefined, {
            isChecked: true,
            eventLabel: 'QUICK_BULK',
            sourceMapperSaleProducts: analyticsSourceProducts,
          });
        },
        (error) => {
          this.errors = error;
          const errorDialog = this._openDialog({
            message: this.errors.message,
            close: () => {
              errorDialog.close();
            },
          });
        }
      );
      this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
      if (this.selectedProducts.length === 0) this.reset();
    }
  }

  reset() {
    this.isShowAddToCartModal = false;
    this.productService.selectProducts = [];
    this.productService.emitResetProduct();
  }

  clickAllSelect() {
    this.isCheckedAll = !this.isCheckedAll;
    this.selectedProducts.map((selectedProduct) => {
      selectedProduct.addBulkChecked = this.isCheckedAll;
    });
    this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
  }

  cehckAllSelect() {
    let cnt = 0;
    this.selectedProducts.forEach((selectedProduct) => {
      if (selectedProduct.addBulkChecked) {
        cnt++;
      }
    });
    this.isCheckedAll = this.selectedProducts.length === cnt;
  }

  onCloseAddToCartModal() {
    this.isShowAddToCartModal = false;
  }

  deleteSelect() {
    const dialog = this._openDialog({
      message: 'Do you want to delete the selected items?',
      close: () => {
        this.selectedProducts = this.selectedProducts.filter((selectedProduct) => !selectedProduct.addBulkChecked);
        if (this.selectedProducts <= 0) {
          this.reset();
        } else {
          this.productService.selectProducts = this.selectedProducts;
          this.productService.emitResetProduct(this.selectedProducts);
        }
        dialog.close();
      },
      cancel: () => {
        dialog.close();
      },
    });
  }
}
